import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';

export default class StackGameButton extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y, config)
    {
        super(scene, x, y);

        const {width=200, height=110, text= ABCyaPhaser.Localization.instance.getLocalizedString("start_button")} = config ?? {width: 200, height: 100, text: ABCyaPhaser.Localization.instance.getLocalizedString("start_button")};

        this.scene.add.existing(this);

        this.scale = 0;
        this.alpha = 0;

        this.setSize(width,height);
        this._bg = this.scene.add.graphics({fillStyle: {color:0x3e9344}, x: -this.width/2, y: -this.height/2}).fillRoundedRect(0,0,this.width, 77, 10).
            fillStyle(0xbde846).fillRoundedRect(0,0,this.width, 72, 10);
        this.add(this._bg);

        this._text = ABCyaPhaser.Text.addText(0,-15, 56, 0x60ba47, FontKeys._odin_roundedregular, text, this);
        ABCyaPhaser.Text.resizeFontToFitWidth(this._text, width - 15, height, 56);
        
        this.setInteractive({ useHandCursor: true });
    }

    popIn()
    {
        ABCyaPhaser.Tweens.addTween(this, 500, { alpha: 1, scale: 1, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);
    }

    popOut()
    {
        ABCyaPhaser.Tweens.addTween(this, 500, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
    }
}